export const KEY = {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  UP: 38,
  DOWN: 40,
  BACKSPACE: 8,
  DELETE: 46,
}

/**
 * Keys the open @-mention list should intercept. BACKSPACE and DELETE stay
 * out so the query can still be edited while suggestions are showing.
 */
export function isSuggestionNavigationKey(keyCode) {
  return (
    keyCode === KEY.ESC ||
    keyCode === KEY.UP ||
    keyCode === KEY.DOWN ||
    keyCode === KEY.RETURN ||
    keyCode === KEY.TAB
  )
}
